import {AxiosInstance} from "axios";
import {ConsumerPathwayStep, ConsumerPathwaySteppableType} from "@/pathway/interfaces/Pathway";
import {ConsumerPathway, Pathway} from "@/program/interfaces/Program";

/**
 * The pathway resource.
 *
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client: AxiosInstance) {
    return {
        async createConsumerPathway(pathway: Pathway, consumerKey: string): Promise<ConsumerPathway> {
            return await client.post('consumer-pathways', {
                consumer_key: consumerKey,
                pathway_id: pathway.id,
            })
                .then(response => response.data.data);
        },
        /**
         * Store a pathway consumer step.
         *
         * @param stepId The pathway step id.
         * @param consumerKey The consumer key.
         * @param consumerSteppableId The consumer steppable id.
         * @param consumerSteppableType The consumer steppable type.
         * @param completed
         *
         * @returns The stored consumer step.
         */
        async storeConsumerStep(
            stepId: number,
            consumerKey: string,
            consumerSteppableId: null | number = null,
            consumerSteppableType: ConsumerPathwaySteppableType = null,
            completed = true
        ): Promise<ConsumerPathwayStep> {
            return await client
                .post('pathway-consumer-steps', {
                    consumer_key: consumerKey,
                    pathway_step_id: stepId,
                    consumer_steppable_id: consumerSteppableId,
                    consumer_steppable_type: consumerSteppableType,
                    completed
                })
                .then(response => response.data.data);
        },

        /**
         * Store consent.
         */
        async storeConsent(consentStepID: number, consumerKey: string): Promise<void> {
            return await client.post(`pathway-step-consents/${consentStepID}/consent`, {
                consumer_key: consumerKey
            });
        },

        /**
         * Track a pathway custom event.
         *
         * @param name The event name.
         * @param pathwayId  The pathway id.
         * @param consumerKey The consumer key.
         * @param data The event data.
         * @returns {*}
         */
        track(name: string, pathwayId: number, consumerKey: null | string = null, data = null) {
            const params: { name: string, consumer_key: string | null, pathway_id: number, data?: any } = {
                name,
                consumer_key: consumerKey,
                pathway_id: pathwayId
            };

            if (data) {
                params.data = data;
            }

            return client
                .post('pathway-events', params)
                .catch(() => Promise.resolve());
        }
    };
}
